import { useMemo } from 'react';
import { computeFunnel, roundForDisplay } from '@/model/funnel';
import type { DisplayNodes, FunnelResult } from '@/model/types';
import { useFunnelStore } from '@/store/useFunnelStore';

/**
 * The model runs once per params change, not once per render. Everything
 * downstream — layout, drawer readouts, impact boxes — reads this.
 */
export function useFunnelResult(): { result: FunnelResult; display: DisplayNodes } {
  const params = useFunnelStore((s) => s.params);
  return useMemo(() => {
    const result = computeFunnel(params);
    return { result, display: roundForDisplay(result) };
  }, [params]);
}
